module.exports = __webpack_public_path__ + "static/media/google-plus.8429afad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_minha-central/Footer/social-icons/google-plus.svg
// module id = 1439
// module chunks = 0